import { ProductCreateFoodcostPricePage } from './../product-create-foodcost-price/product-create-foodcost-price';
import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../../../ingredients/services";
import { Globals } from "../../../../../globals";
import { FormBuilder } from "@angular/forms";
import { ProductsServices } from '../../../services';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateFoodcostQuantityCostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-foodcost-quantity-cost',
  templateUrl: 'product-create-foodcost-quantity-cost.html',
})

export class ProductCreateFoodcostQuantityCostPage {

  update_state: boolean = false;
  product_uid: string;
  real_weight: number = 0;
  total: number = 0;
  total_ration: number = 0;
  foodcost_parts: number = 1;
  product_name: any;
  product: any;
  products: any;

  show_alert: boolean = true;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public fb: FormBuilder,
    public productsServices: ProductsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {

    this.product_uid = this.navParams.get('product_uid');
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.products = this.navParams.get('products');
    this.product = this.navParams.get('product');

    if (this.update_state) {
      this.foodcost_parts = this.products.foodcost_parts;
      //this.pvp = this.navParams.get('pvp');
    } else {
      //this.pvp = 0;
    }


    this.calculateInitial();
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  calculateRow(index) {
    var quantity = this.productsServices.prodings_array_tmp[index][12];
    var waste = this.productsServices.prodings_array_tmp[index][14];
    var price = this.productsServices.prodings_array_tmp[index][5];

    //Calculo de la merma
    this.productsServices.prodings_array_tmp[index][13] = this.ingredientsServices.calculateWaste(waste, quantity);
    //Calculo precio
    this.productsServices.prodings_array_tmp[index][15] = this.ingredientsServices.calculatePrice(price, this.productsServices.prodings_array_tmp[index][13], this.productsServices.prodings_array_tmp[index][2]);
    this.calculateTotal();
  }

  calculateTotal() {
    if (this.productsServices.prodings_array_tmp.length == 0) {
      this.total = 0;
    } else {
      var _total = 0;
      for (var i = 0; this.productsServices.prodings_array_tmp.length > i; i++) {
        _total += this.productsServices.prodings_array_tmp[i][15];
      }
      this.total = _total;
    }

    this.total_ration = this.total / this.foodcost_parts;
  }

  calculateInitial() {
    for (var i = 0; this.productsServices.prodings_array_tmp.length > i; i++) {
      this.calculateRow(i);
    }
  }

  delete(index) {
    this.productsServices.prodings_array_tmp.splice(index, 1);
    this.calculateInitial();
    this.calculateTotal();
  }

  update() {
    this.show_alert = false;
    var _array = Array();
    var _allergens = Array();

    for (var i = 0; this.productsServices.prodings_array_tmp.length > i; i++) {
      var measurement = '';
      if (this.productsServices.prodings_array_tmp[i][2] === 'kg') {
        measurement = 'gr';
      } else if (this.productsServices.prodings_array_tmp[i][2] === 'l') {
        measurement = 'ml';
      } else {
        measurement = 'ud.';
      }

      _array.push({
        quantity: this.productsServices.prodings_array_tmp[i][12],
        uid: this.productsServices.prodings_array_tmp[i][0],
        quantity_gross: this.productsServices.prodings_array_tmp[i][13],
        waste: this.productsServices.prodings_array_tmp[i][14],
        provider_static: this.productsServices.prodings_array_tmp[i][6],
        name_static: this.productsServices.prodings_array_tmp[i][1],
        measurement_static: measurement,
        price_static: this.productsServices.prodings_array_tmp[i][15],
        allergens: this.productsServices.prodings_array_tmp[i][8],
        price_notax: this.productsServices.prodings_array_tmp[i][5],
        type: this.productsServices.prodings_array_tmp[i][23],
        updated_at: new Date(),
      });

      for (var j = 0; this.productsServices.prodings_array_tmp[i][8].length > j; j++) {
        _allergens.push(
          this.productsServices.prodings_array_tmp[i][8][j],
        );
      }


    }

    var _uniqueAllergens = [];
    $.each(_allergens, function (i, el) {
      if ($.inArray(el, _uniqueAllergens) === -1) _uniqueAllergens.push(el);
    });

    if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.
      this.ingredientsServices.afs.collection('products').doc(this.product_uid).update({
        'foodcost': _array,
        'price_static': this.total,
        'real_weight': this.real_weight,
        'allergens': _uniqueAllergens,
        'foodcost_parts': this.foodcost_parts,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        if (this.update_state) {
          this.globals.GAtrackView('Products', 'Products - Quantity - Update', this.globals.restaurant.email, 'Create/Update', 'Update quantity', 'Products', this.product_name);
          this.navCtrl.remove(this.navCtrl.getPrevious().index);
          this.navCtrl.pop();
        } else {
          this.globals.GAtrackView('Products', 'Products - Quantity - Create', this.globals.restaurant.email, 'Create/Update', 'Create quantity', 'Products', this.product_name);
          this.navCtrl.push(ProductCreateFoodcostPricePage, {
            update_state: this.update_state,
            product_uid: this.product_uid,
            product_name: this.product_name
          })
        }
      });
    } else {
      this.navCtrl.push(ProductCreateFoodcostPricePage, {
        update_state: this.update_state,
        product_uid: this.product_uid,
        product_name: this.product_name
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-quantity-cost/product-create-foodcost-quantity-cost.ts